export default __webpack_public_path__ + "static/media/brosucsess.b48f5de6.png";